import { defineComponent } from 'vue';
import { CashierSettingsButtonName } from '@/models/cashier-settings/cashier-settings.model';
import {
  Back,
} from '@element-plus/icons-vue';

const icons = {
  Back,
};

export default defineComponent({
  name: 'SettingsScreenHeader',
  props: {
    selectedCountryName: {
      type: String,
      required: true,
    },
    isSaveButtonDisabled: {
      type: Boolean,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['close', 'submit'],
  setup() {
    return {
      CashierSettingsButtonName,
      icons,
    };
  },
});
